import React from 'react'
import { Segment, Header } from 'semantic-ui-react'
import PartnerForm from '../../components/partners/form'

const NewPartner = () => {
  return (
    <div>
      <Segment color="black">
        <Header size="large"> New Partner </Header>
        <PartnerForm />
      </Segment>
    </div>
  )
}

export default NewPartner



// WEBPACK FOOTER //
// ./src/containers/partners/new.js